<template>
  <div
    v-if="show"
    class="fixed bottom-4 right-4 z-50 max-w-sm"
  >
    <div
      v-if="$page.props.flash.success"
      class="flex items-center justify-between gap-3 rounded-lg bg-green-500 px-3 py-2 shadow-lg"
    >
      <div class="flex items-center gap-2">
        <svg
          class="h-3.5 w-3.5 shrink-0 fill-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
        </svg>
        <div class="text-xs font-medium text-white">
          {{ $page.props.flash.success }}
        </div>
      </div>
      <button type="button" class="group shrink-0 p-1" @click="show = false">
        <svg
          class="block h-3 w-3 fill-green-800 group-hover:fill-green-700"
          xmlns="http://www.w3.org/2000/svg"
          width="235.908"
          height="235.908"
          viewBox="0 0 278.046 126.846 235.908 235.908"
        >
          <path
            d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"
          />
        </svg>
      </button>
    </div>
    <div
      v-else-if="$page.props.flash.alert"
      class="flex items-center justify-between gap-3 rounded-lg bg-red-400 px-3 py-2 shadow-lg"
    >
      <div class="flex items-center gap-2">
        <svg
          class="h-3.5 w-3.5 shrink-0 fill-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z"
          />
        </svg>
        <div class="text-xs font-medium text-white">
          {{ $page.props.flash.alert }}
        </div>
      </div>
      <button type="button" class="group shrink-0 p-1" @click="show = false">
        <svg
          class="block h-3 w-3 fill-red-800 group-hover:fill-red-700"
          xmlns="http://www.w3.org/2000/svg"
          width="235.908"
          height="235.908"
          viewBox="0 0 278.046 126.846 235.908 235.908"
        >
          <path
            d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"
          />
        </svg>
      </button>
    </div>
    <div
      v-if="hasFormErrors"
      class="flex items-center justify-between gap-3 rounded-lg bg-red-400 px-3 py-2 shadow-lg"
    >
      <div class="flex items-center gap-2">
        <svg
          class="h-3.5 w-3.5 shrink-0 fill-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z"
          />
        </svg>
        <div class="text-xs font-medium text-white">
          <span v-if="formErrorCount === 1">There is one form error.</span>
          <span v-else>There are {{ formErrorCount }} form errors.</span>
        </div>
      </div>
      <button type="button" class="group shrink-0 p-1" @click="show = false">
        <svg
          class="block h-3 w-3 fill-red-600 group-hover:fill-red-700"
          xmlns="http://www.w3.org/2000/svg"
          width="235.908"
          height="235.908"
          viewBox="0 0 278.046 126.846 235.908 235.908"
        >
          <path
            d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';

export default {
  data() {
    return {
      show: false,
    };
  },
  computed: {
    formErrorCount() {
      return Object.keys(this.$page.props.errors || {}).length;
    },
    hasFormErrors() {
      return this.formErrorCount > 0;
    },
  },
  mounted() {
    this.syncFromFlash();
    this.removeSuccessListener = router.on('success', () => {
      this.syncFromFlash();
    });
  },
  beforeUnmount() {
    this.removeSuccessListener?.();
  },
  methods: {
    syncFromFlash() {
      const flash = this.$page.props.flash || {};
      this.show = !!(flash.success || flash.alert || this.hasFormErrors);
    },
  },
};
</script>
